import { DefinedAmount } from "./calculateLossValue";

export function resultIsPerfect(lossValue: DefinedAmount) {
  // TODO: Recheck this!
  return lossValue.max === 0;
}
